/**
 * Application Version Configuration
 * Production-ready version tracking
 */

export const APP_VERSION = {
  major: 1,
  minor: 0,
  patch: 0,
  build: Date.now(),
  
  // Semantic version string
  get version() {
    return `${this.major}.${this.minor}.${this.patch}`;
  },
  
  // Full version with build
  get fullVersion() {
    return `${this.version}.${this.build}`;
  },
  
  // Production status
  isProduction: true,
  
  // Release information
  release: {
    name: 'Monte Carlo Production Launch',
    date: new Date('2025-01-31'),
    features: [
      'Enhanced Monte Carlo Simulation Engine',
      'Correlation Workbench', 
      'Australian Tax Optimization',
      'Unified Debt Analytics',
      'Production Security Hardening',
      'Comprehensive Testing Suite',
      'Success Definitions & Goal Tracking',
      'Advanced Reporting System'
    ]
  }
};

export const getVersionInfo = () => ({
  version: APP_VERSION.version,
  fullVersion: APP_VERSION.fullVersion,
  isProduction: APP_VERSION.isProduction,
  buildTime: new Date(APP_VERSION.build).toISOString(),
  release: APP_VERSION.release
});